import React, { createContext, useContext, useState } from 'react';

const ContextMenuContext = createContext();

const ContextMenuProvider = ({ children }) => {
  const [contextMenuItems, setContextMenuItems] = useState([]);
  const [actionButton, setActionButton] = useState(null);

  const setMenuItems = components => {
    if (!Array.isArray(components)) {
      console.error('setMenuItems expects an array of components');
      return;
    }
    setContextMenuItems(components);
  };
  const addActionButton = components => {
    setActionButton(components);
  };

  const updateMenuItemProps = (index, newProps) => {
    setContextMenuItems(prevComponents => {
      const updatedComponents = [...prevComponents];
      const componentInstance = updatedComponents[index].ref; // Access the component instance
      if (componentInstance) {
        componentInstance.updateProps(newProps); // Assume the component has an updateProps method
      }
      return updatedComponents;
    });
  };

  const clearAllContext = () => {
    setContextMenuItems([]);
    setActionButton(null);
  };

  return (
    <ContextMenuContext.Provider
      value={{
        contextMenuItems,
        setMenuItems,
        actionButton,
        addActionButton,
        clearAllContext
      }}
    >
      {children}
    </ContextMenuContext.Provider>
  );
};

export const useContextMenu = () => {
  const contextMenu = useContext(ContextMenuContext);
  if (!contextMenu) {
    // If context is not available, return a default object to avoid errors
    return {
      contextMenuItems: [],
      setMenuItems: () => {},
      actionButton: null,
      addActionButton: () => {},
      clearAllContext: () => {}
    };
  }
  return contextMenu;
};

export default ContextMenuProvider;
